module.exports = __webpack_public_path__ + "static/img/hahmo-omantuottamisen-prosessi.85ff006.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hahmo-omantuottamisen-prosessi.png
// module id = zKh+
// module chunks = 1